import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Buildings } from "@phosphor-icons/react";

export default function CompanyCreateForm({ name, setName, busy, onSubmit }) {
  return (
    <div className="max-w-2xl">
      <div className="gf-overline">Company</div>
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-2">
        Create your workspace.
      </h1>
      <p className="text-zinc-600 mt-3 text-sm leading-relaxed">
        One workspace per organization. The creator becomes the manager and can invite members.
      </p>
      <form onSubmit={onSubmit} className="mt-8 border border-zinc-200 bg-white p-6" data-testid="company-create-form">
        <div className="flex items-center gap-2 mb-4">
          <Buildings size={20} />
          <div className="gf-overline">New company</div>
        </div>
        <Label className="gf-overline">Company name</Label>
        <Input
          data-testid="company-name-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Acme Civic Foundation"
          className="gf-sharp mt-2 border-zinc-300 bg-white"
        />
        <Button
          type="submit"
          disabled={busy}
          data-testid="company-create-btn"
          className="gf-sharp mt-4 bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide"
        >
          {busy ? "Creating…" : "Create company"}
        </Button>
      </form>
    </div>
  );
}
